<app-spinner message='Fetching results…' *ngIf="loading"></app-spinner>
<div *ngIf="!loading && pdfUrl !== undefined">
 <iframe [attr.src]="pdfUrl" id="emb-pdf" ></iframe>
</div>
